//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
export default {
  name: 'rb-3d-banner',
  components: {
    RbBanner,
  },
  props: {
    isDummyBanner: {
      type: Boolean,
      default: false,
    },
  },
}
